// Sovyer: "The Exhibit" page — wires the variant pills to the hidden form input and the
// displayed price. The form itself is a plain Shopify product form (action="/cart/add"),
// so purchasing still works with this script blocked or failing to load; this only upgrades
// the size-picker UX.
(function () {
  function init() {
    document.querySelectorAll('.exhibit-form').forEach(function (form) {
      var hiddenInput = form.querySelector('.exhibit-form__variant-id');
      var priceEl = form.querySelector('[data-exhibit-price]');
      var pills = form.querySelectorAll('.exhibit-pill');

      pills.forEach(function (pill) {
        var radio = pill.querySelector('input[type="radio"]');
        if (!radio) return;

        radio.addEventListener('change', function () {
          if (!radio.checked) return;

          pills.forEach(function (p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');

          if (hiddenInput) hiddenInput.value = radio.value;
          if (priceEl && radio.dataset.price) priceEl.textContent = radio.dataset.price;
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
